import React from "react";
import { SelectInput, required } from "react-admin";
import { useFormContext } from "react-hook-form";

const PracticeInput = ({ choices = [], source = "practiceId", readOnly = false }) => {
  const { setValue } = useFormContext();

  const handleChange = event => {
    const semesters = choices.find(choice => choice.id === event.target.value)?.semesters ?? [];
    setValue("semester", semesters[0] ?? null);
  };

  return (
    <SelectInput
      source={source}
      label="Учебна практика"
      choices={choices}
      optionText="name"
      optionValue="id"
      validate={required("Полето е задължително")}
      readOnly={readOnly}
      onChange={handleChange}
      fullWidth
    />
  );
};

export default PracticeInput;
